import React from 'react'
import { useSelector } from 'react-redux'
import { Grid, Typography } from '../../../../../../../components/mui/Core/index'
import Constants from '../../../../../../../constants/en.json'

export function ItemOutOfStock() {
  const selectedInventoryItem = useSelector((state) => state.inventory.selectedInventoryItem)

  const outOfStockStyle = {
    textAlign: 'center',
    display: 'block',
  }

  return (
    <Grid size={{ xs: 12 }} sx={{ px: 13, mt: 3 }}>
      <Typography variant='message' sx={outOfStockStyle}>
        {`${Constants.itemDetails.NDC_ITEM_NUMBER} ${selectedInventoryItem?.itemNumber} ${Constants.itemDetails.IS_OUT_OF_STOCK}`}
      </Typography>
      <Typography variant='message' sx={outOfStockStyle}>
        {Constants.itemDetails.RESTOCK_THIS_ITEM}
      </Typography>
    </Grid>
  )
}

export default ItemOutOfStock
